<template>
  <div class="row">
    <div class="col-12">
      <div class="col-12" v-if="states.isWindowLessXl">
        <a class="badge btn-outline-primary m-1" href="#q-en">
          Question(en)
        </a>
        <a class="badge btn-outline-primary m-1" href="#sol-en">
          Solution(en)
        </a>
        <a class="badge btn-outline-primary m-1" href="#q-zh">
          Question(zh)
        </a>
        <a class="badge btn-outline-primary m-1" href="#sol-zh">
          Solution(zh)
        </a>
      </div>
      <div class="col-12" v-else>
        <a class="badge btn-outline-primary m-1" href="#q-zh">
          Question
        </a>
        <a class="badge btn-outline-primary m-1" href="#sol-zh">
          Solution
        </a>
      </div>
    </div>
    <div class="col-8 left-pane">
      <div class="row no-gutters">
        <div class="col-xl-6 p-1">
          <template v-if="question">
            <div id="q-en" class="col-12" v-if="question.content">
              <span class="mj" v-html="question.content" />
            </div>
            <div class="col-12" v-if="question.contentImageData">
              <img
                class="content-image"
                v-bind:src="
                  'data:image/jpeg;base64,' + question.contentImageData
                "
              />
            </div>
            <div class="col-12 my-3">
              <h5>
                Answers
              </h5>
            </div>
            <div class="col-12" v-if="question.answers">
              <ul class="ans-lists">
                <template v-for="(a, i) in question.answers">
                  <li class="answer-style" :key="i">
                    <span>{{ listChar(i) + '. ' }}</span>
                    <span class="mj" v-html="a" />
                  </li>
                </template>
              </ul>
            </div>
            <div class="col-12 my-3" v-if="question.answerImagesData">
              <ul class="ans-lists">
                <template v-for="(a, i) in question.answerImagesData">
                  <li class="answer-style" :key="i">
                    <span>{{ listChar(i) }}</span>
                    <img
                      class="answer-image"
                      v-bind:src="'data:image/jpeg;base64,' + a"
                    />
                  </li>
                </template>
              </ul>
            </div>
            <div id="sol-en" class="col-12 my-3">
              <h5>Solution</h5>
            </div>
            <div class="col-12" v-if="question.solution">
              <div class="table-wrapper">
                <table class="table">
                  <tr>
                    <th style="width:75px">Line #</th>
                    <th></th>
                  </tr>
                  <tr v-for="(rows, i) in question.solution" :key="i">
                    <td>{{ i + 1 }}</td>
                    <td>
                      <span
                        v-if="rows.type === 'text_left'"
                        class="example-row align-center mj"
                        v-html="rows.data"
                      />
                      <span
                        v-if="rows.type === 'text_center'"
                        class="example-row align-center mj"
                        v-html="rows.data"
                      />
                      <div
                        v-if="rows.type === 'img'"
                        class="example-row example-image align-center"
                      ></div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </template>
        </div>
        <div class="col-xl-6 p-1">
          <div id="q-zh" class="col-12" v-if="refQuestion.content">
            <span class="mj" v-html="refQuestion.content" />
          </div>
          <div class="col-12" v-if="question.contentImageData">
            <img
              class="content-image"
              v-bind:src="'data:image/jpeg;base64,' + question.contentImageData"
            />
          </div>
          <div class="col-12 my-3">
            <h5>
              Answers
            </h5>
          </div>
          <div class="col-12" v-if="refQuestion.answers">
            <ul class="ans-lists">
              <template v-for="(a, i) in refQuestion.answers">
                <li class="answer-style" :key="i">
                  <span>{{ listChar(i) + '. ' }}</span>
                  <span class="mj" v-html="a" />
                </li>
              </template>
            </ul>
          </div>
          <div class="col-12 my-3" v-if="question.answerImagesData">
            <ul class="ans-lists">
              <template v-for="(a, i) in question.answerImagesData">
                <li class="answer-style" :key="i">
                  <span>{{ listChar(i) }}</span>
                  <img
                    class="answer-image"
                    v-bind:src="'data:image/jpeg;base64,' + a"
                  />
                </li>
              </template>
            </ul>
          </div>
          <div id="sol-zh" class="col-12 my-3">
            <h5>Solution</h5>
          </div>
          <div class="col-12" v-if="refQuestion.solution">
            <div class="table-wrapper">
              <table class="table">
                <tr>
                  <th style="width:75px">Line #</th>
                  <th></th>
                </tr>
                <tr v-for="(rows, i) in refQuestion.solution" :key="i">
                  <td>{{ i + 1 }}</td>
                  <td>
                    <span
                      v-if="rows.type === 'text_left'"
                      class="example-row align-center mj"
                      v-html="rows.data"
                    />
                    <span
                      v-if="rows.type === 'text_center'"
                      class="example-row align-center mj"
                      v-html="rows.data"
                    />
                    <div
                      v-if="rows.type === 'img'"
                      class="example-row example-image align-center"
                    ></div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-4 right-pane">
      <div class="col-12">
        <h4><span class="badge badge-secondary">Simple check</span></h4>
      </div>
      <div class="col-12 check-step">
        <span class="badge badge-info">Step 1</span> Spot problems in question
        and answers.
      </div>
      <div class="col-12 m-3">
        <div v-for="(c, i) in err_check" :key="i">
          <div v-if="i == 0">
            <div class="form-check m-2">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="err_check[0].checked"
                @change="localEventHandler('click-no-problem-qa')"
              />
              <label class="form-check-label">
                {{ c.caption }}
              </label>
            </div>
          </div>
          <div v-else-if="i <= 3">
            <div class="form-check m-2">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="err_check[i].checked"
                @change="localEventHandler('click-problem-qa')"
              />
              <label class="form-check-label">
                {{ c.caption }}
              </label>
            </div>
            <div class="form-group m-3" v-if="c.checked == true">
              <textarea
                :class="{
                  'form-control': true,
                  'is-invalid': c.comment == ''
                }"
                rows="3"
                maxlength="1024"
                placeholder="Please specify"
                v-model="err_check[i].comment"
              />
            </div>
          </div>
        </div>
        <small class="invalid" v-if="!validate_input['ans-spot-qa']">
          Please choose at least one of the above options.
        </small>
      </div>
      <div class="col-12 check-step">
        <span class="badge badge-info">Step 2 </span> Spot problems in solution.
      </div>
      <div class="col-12 m-3">
        <small> Please specify the line numbers in the comment.</small>
        <div v-for="(c, i) in err_check" :key="i">
          <div v-if="i == 4">
            <div class="form-check m-2">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="err_check[4].checked"
                @change="localEventHandler('click-no-problem-s')"
              />
              <label class="form-check-label">
                {{ c.caption }}
              </label>
            </div>
          </div>
          <div v-if="i > 4">
            <div class="form-check m-2">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="err_check[i].checked"
                @change="localEventHandler('click-problem-s')"
              />
              <label class="form-check-label">
                {{ c.caption }}
              </label>
            </div>
            <div class="form-group m-3" v-if="c.checked == true">
              <textarea
                :class="{
                  'form-control': true,
                  'is-invalid': c.comment == ''
                }"
                rows="3"
                maxlength="1024"
                placeholder="Please specify"
                v-model="err_check[i].comment"
              />
            </div>
          </div>
        </div>
        <small class="invalid" v-if="!validate_input['ans-spot-s']">
          Please choose at least one of the above options.
        </small>
      </div>
      <div class="col-12 ml-2 mt-3">
        <button
          type="button"
          class="btn btn-outline-primary"
          :disabled="states.submitting"
          @click="localEventHandler('click-submit')"
        >
          Submit
        </button>
      </div>
      <div class="col-12 ml-2" v-if="!validate_input['no-empty-comment']">
        <small class="invalid">
          For each checked reponse, please enter your comment.
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import api_tester from '@/api/api_tester'
export default {
  props: {
    seqId: 0,
    question: { type: Object, default: _ => {} },
    refQuestion: { type: Object, default: _ => {} },
    eventHandler: { type: Function, default: (name, event) => {} }
  },
  data () {
    return {
      err_check: [],
      validate_input: {
        'no-empty-comment': true,
        'ans-spot-qa': true,
        'ans-spot-s': true
      },
      states: {
        submitting: false,
        isWindowLessXl: window.innerWidth < 1200
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onWindowsResize)
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onWindowsResize)
  },
  created () {
    this.err_check = [
      {
        caption: 'No problem spotted in the questions and the answers.',
        code: null,
        checked: false
      },
      {
        caption:
          'The question and/or answers have typos, grammar or format issues.',
        code: 'qa_typo_grammar_format',
        checked: false,
        comment: ''
      },
      {
        caption: 'The question and/or answers is ambiguous or misleading.',
        code: 'qa_ambiguous',
        checked: false,
        comment: ''
      },
      { caption: 'Others', checked: false, comment: '', code: 'qa_others' },
      {
        caption: 'No problem spotted in the solutions.',
        code: null,
        checked: false
      },
      {
        caption: 'The solution has typos, grammar or format issues.',
        code: 's_typo_grammar_format',
        checked: false,
        comment: ''
      },
      {
        caption: 'The solution is not answering the question.',
        code: 's_no_answer',
        checked: false,
        comment: ''
      },
      {
        caption: "The solution doesn't give a conclusion.",
        code: 's_no_conclusion',
        checked: false,
        comment: ''
      },
      {
        caption: 'The solution is wrong.',
        code: 's_incorrect',
        checked: false,
        comment: ''
      },
      { caption: 'Others', code: 's_others', checked: false, comment: '' }
    ]
  },
  methods: {
    localEventHandler (name, event) {
      if (name == 'click-submit') {
        this.submit()
      } else if (name == 'click-no-problem-qa') {
        for (var i = 1; i <= 3; ++i) {
          this.err_check[i].checked = false
        }
      } else if (name == 'click-problem-qa') {
        this.err_check[0].checked = false
      } else if (name == 'click-no-problem-s') {
        for (var i = 5; i <= 8; ++i) {
          this.err_check[i].checked = false
        }
      } else if (name == 'click-problem-s') {
        this.err_check[4].checked = false
      } else if (name == 'window-resize') {
        this.states.windowWidth = window.innerWidth
        this.states.isWindowLessXl = window.innerWidth < 1200
      }
    },
    listChar (num) {
      return String.fromCharCode(65 + num)
    },
    validate () {
      this.validate_input['no-empty-comment'] = true
      this.err_check.map(x => {
        if (x.comment == '' && x.checked == true && x.code != null) {
          this.validate_input['no-empty-comment'] = false
        }
      })
      this.validate_input['ans-spot-qa'] =
        this.err_check[0].checked ||
        this.err_check[1].checked ||
        this.err_check[2].checked ||
        this.err_check[3].checked
      this.validate_input['ans-spot-s'] =
        this.err_check[4].checked ||
        this.err_check[5].checked ||
        this.err_check[6].checked ||
        this.err_check[7].checked ||
        this.err_check[8].checked ||
        this.err_check[9].checked
      return (
        this.validate_input['no-empty-comment'] &&
        this.validate_input['ans-spot-qa'] &&
        this.validate_input['ans-spot-s']
      )
    },
    reset () {
      for (var i = 0; i < this.err_check.length; ++i) {
        this.err_check[i].checked = false
        this.err_check[i].comment = ''
      }
    },
    submit () {
      if (this.validate()) {
        this.states.submitting = true
        // do submit, then
        var report = this.err_check.filter(
          x => x.checked == true && x.code != null
        )
        Promise.all(
          [api_tester.submit_ts(this.seqId)].concat(
            report.map(x =>
              api_tester.save_report(this.seqId, x.code, x.comment)
            )
          )
        ).then(q => {
          this.states.submitting = false
          var success = true
          q.map(x => {
            if (x.success != true) {
              success = false
            }
          })
          if (success == true) {
            this.eventHandler('submit-success')
          } else {
            this.eventHandler('submit-error')
          }
        })
      }
    },
    onWindowsResize () {
      this.localEventHandler('window-resize')
    }
  }
}
</script>

<style scoped>
.left-pane {
  max-height: 75vh;
  height: 75vh;
  overflow-x: hidden;
}
.right-pane {
  max-height: 75vh;
  height: 75vh;
  overflow-x: hidden;
}
.ans-lists {
  list-style-type: none;
  width: 100%;
  padding-inline-start: 10px !important;
}
.content-image {
  max-width: 350px;
  vertical-align: text-top;
}

.check-step {
  margin: 10px 10px;
  width: 100%;
  font-weight: bold;
  font-size: 20px;
}

.answer-style {
  padding: 10px 10px;
  margin: 5px 5px;
  font-size: 18px;
  border-radius: 23px;
  border: solid 1px #979797;
  display: inline-block;
}

.answer-image {
  max-width: 250px;
  vertical-align: text-top;
}

.answer-options {
  margin: 10px 5px !important;
  font-size: 18px;
}

.invalid {
  font-size: 12px;
  color: red;
}

.table-wrapper {
  max-width: 100%;
  max-height: none;
  overflow-x: auto;
  overflow-y: hidden;
}

td {
  word-wrap: break-word;
}
</style>
